export function streamXlsxFileWithBlob (data, fileName) {
  const url = window.URL.createObjectURL(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}`);
  document.body.appendChild(link);
  link.click();
}



// WEBPACK FOOTER //
// ./src/utils/streamFile.js